var _polyline, _polyline2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-maximize-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15 3 21 3 21 9"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "9 21 3 21 3 15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 3,
    x2: 14,
    y2: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 10,
    y2: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.4bac7bae1d8b2f4f5e6fb4159c9ca872.svg";
export { ForwardRef as ReactComponent };